/**
 * @generated SignedSource<<54a3f63a97dfbed2966087032b7f747b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type NoteStreamType = "goalset" | "meeting" | "oneonone" | "personal";
import { FragmentRefs } from "relay-runtime";
export type ShareButton_note$data = {
  readonly id: string;
  readonly noteType: NoteStreamType;
  readonly stream: {
    readonly id: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"RequestAccessTooltip_note">;
  readonly " $fragmentType": "ShareButton_note";
};
export type ShareButton_note$key = {
  readonly " $data"?: ShareButton_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShareButton_note">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShareButton_note",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "noteType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "stream",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RequestAccessTooltip_note"
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "1b63733d914ecb96d03950b4a142ce24";

export default node;
